
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/team/members",
      function () {
        return require("private-next-pages/my-account/team/members.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/team/members"])
      });
    }
  